export enum EventCalendarFiltersEnum {
  ALL = 'ALL',
  APPROVED = 'APPROVED',
  IN_PROGRESS = 'IN_PROGRESS',
}
